<template>
  <div id="app">
    <div class="bg-decor" aria-hidden="true">
      <div class="blob blob--a"></div>
      <div class="blob blob--b"></div>
      <div class="blob blob--c"></div>
    </div>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
